import { FC, lazy, Suspense } from 'react';
import { ChartProps } from './Chart.helpers';
import { LineChartSkeleton } from './LineChartSkeleton';

const LineChartComponent = lazy(() => import('./LineChartInternal'));
const StackedBarChartComponent = lazy(() => import('./StackedBarChartInternal'));

export const LineChart: FC<ChartProps<'line'>> = props => {
  return (
    <Suspense fallback={<LineChartSkeleton />}>
      <LineChartComponent {...props} />
    </Suspense>
  );
};

export const StackedBarChart: FC<ChartProps<'bar'>> = props => {
  return (
    <Suspense fallback={<LineChartSkeleton />}>
      <StackedBarChartComponent {...props} />
    </Suspense>
  );
};
